import { render, staticRenderFns } from "./EconomicGroupList.vue?vue&type=template&id=66617b35"
import script from "./EconomicGroupList.vue?vue&type=script&lang=js"
export * from "./EconomicGroupList.vue?vue&type=script&lang=js"
import style0 from "./EconomicGroupList.vue?vue&type=style&index=0&id=66617b35&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports